import Button from 'common/components/Button'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

export const ShareButtonContainer = connect(
  null,
  (dispatch, {item}) => ({
    onClick: () => dispatch(push('.', { hiddenHash: `#share/${item.type}/${item.id}` }))
  })
)

export default ShareButtonContainer(Button)
